import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface SnackbarComponentProps {
  error: boolean;
  errorMessage: string;
  hideError: () => void;
}

const SnackbarComponent: React.FC<SnackbarComponentProps> = ({
  error,
  errorMessage,
  hideError,
}) => {

  const action = (
    <>     
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"        
        onClick={hideError}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>    
);

  return (
    <div>
      <Snackbar open={error} autoHideDuration={6000} action={action}  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} onClose={hideError}
         message={errorMessage}
      >
        {/* <Alert
          onClose={hideError}
          severity="error"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert> */}
      </Snackbar>
    </div>
  );
};

export default SnackbarComponent;
